<template>
  <div class="flw-progress">
    <div class="content" ref="contentPro">
      <span class="count">{{countNumber}}</span>
      <span class="complete">{{complateNumber}}</span>
      <div class="progress" style="width: 0px;" ref="progress"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    complateNumber: {
      type: Number,
      default: 0
    },
    countNumber: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    if (this.complateNumber === 0) { return }
    let boxWidth = this.$refs.contentPro.offsetWidth
    let onePic = boxWidth / this.complateNumber
    let progress = onePic * this.countNumber
    this.$refs.progress.style.width = progress + 'px'
  },
  data() {
    return {

    }
  }
}
</script>
<style lang="scss">
.flw-progress {
  .content {
    width: 193px;
    height: 18px;
    border-radius: 4px;
    background-color: rgba(80, 154, 255, 0.19);
    position: relative;
    overflow: hidden;
  }
  .progress {
    background-color: rgba(80, 154, 255, 0.6);
    height: 100%;
    transition: all 1s;
  }
  .count {
    position: absolute;
    left: 7px;
    top: 50%;
    transform: translate(0, -50%);
    font-size: 14px;
    z-index: 1;
  }
  .complete {
    position: absolute;
    right: 7px;
    top: 50%;
    transform: translate(0, -50%);
    font-size: 14px;
    color: rgba(32, 32, 32, 0.4);
    z-index: 1;
  }
}
</style>
